<template>
     <v-dialog v-model="dialog" max-width="500px" scrollable>
            <v-card class="add-dialog">
                <v-card-title class="dialog-title">
                    <v-icon class="dialog-icon">mdi-plus-circle</v-icon>
                    <span>Add New Commission</span>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" v-model="valid" class="commision-form">
                        <v-text-field
                            v-model="newCommission.commissionName"
                            label="Commission Name"
                            outlined
                            :rules="[v => !!v || 'Name is required']"
                            required
                            class="mb-4"
                        />
                        <v-text-field
                            v-model="newCommission.commission_percentage"
                            label="Percentage"
                            type="number"
                            outlined
                            suffix="%"
                            :rules="[
                                v => !!v || 'Percentage is required', 
                                v => v > 0 || 'Must be greater than 0',
                                v => v <= 100 || 'Must be less than or equal to 100'
                            ]"
                            required
                            class="mb-4"
                        />
                        <v-select
                            v-model="newCommission.status"
                            :items="['Active', 'Inactive']"
                            label="Status"
                            outlined
                            :rules="[v => !!v || 'Status is required']"
                            required
                        />
                    </v-form>
                </v-card-text>
                <v-card-actions class="dialog-actions">
                    <v-spacer />
                    <v-btn text @click="onClose">Cancel</v-btn>
                    <v-btn class="add-btn" @click="addCommission">Add Commission</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
export default({
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function
    }
  },
  data(){
    return {
      showAddDialog: this.dialog,
      newCommission: {
        commissionName: '',
        commission_percentage: null,
        status: 'Active'
      },
      valid: false
    };
  },
  methods: {
    ...mapActions({
        createCommission: 'commission/createCommission'
    }),
    async addCommission() {
      const form = this.$refs.form;
      // Validate the form before submitting
      const isValid = await form.validate ? await form.validate() : this.valid;
      if (!isValid) return;

      const payload = {
        commissionName: this.newCommission.commissionName,
        commission_percentage: this.newCommission.commission_percentage,
        status: this.newCommission.status
      };
      this.createCommission(payload)
        .then(() => {
          this.resetForm();
          this.onClose();
        })
        .catch(error => {
          console.error('Error adding commission:', error);
        });
    },
    resetForm() {
      this.newCommission = {
        commissionName: '',
        commission_percentage: null,
        status: ''
      };
      this.valid = false;
    }
  },
})
</script>

<style scoped>
        
/* Dialog Styles */
.add-dialog {
  border-radius: 12px;
}

.dialog-title {
  background: linear-gradient(135deg,#084468,#3b7ca1);
  color: white;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  padding: 16px;
}

.dialog-icon {
  color: white;
}

.dialog-actions {
  padding: 8px 16px 16px;
}

.add-btn{
    background: linear-gradient(135deg,#084468,#3b7ca1);
  color: white;
}


.commision-form{
    margin-top: 12px;
}
</style>